import * as Constants from 'components/landing/constants';

import { useEffect, useState } from 'react';

// import carIconMapper from 'components/icons/landing/car-brand-icons/mapper';
import dynamic from 'next/dynamic';
import ErrorMessage from 'components/widgets/error-message';
import getDynamicData from 'utils/dynamic-tables/get-dynamic-data';
import getQuotationAvailableByCar from 'utils/query-data-parser/get-quotation-available-by-car';
import HeaderExpansibleBase from 'components/landing/tables/components/expandible-table-items-base/header-expansible-base';
import Image from 'core/image';
import insuranceLogoMapper from 'utils/insurance-logo-mapper/insurance-logo-mapper';
import LoadingTable from 'components/widgets/loading-table';
import PropTypes from 'prop-types';
import QuotationAvailableByCarsHeader from 'components/landing/tables/quotation-available-by-car/header';
import QuotationAvailableByCarsItem from 'components/landing/tables/quotation-available-by-car/item';
import QuotationAvailableByCarSmallItem from 'components/landing/tables/quotation-available-by-car/item-small';
import removeDuplicateCoverages from 'utils/remove-duplicate-coverages';
import styles from 'styles/LandingExpansibleTable.module.scss';
import TableWrapper from 'components/landing/tables/components/table-wrapper/table-wrapper';
import titleStyles from 'styles/LandingTablesComponents.module.scss';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import useRichTranslation from 'hooks/useRichTranslation';
import variables from 'styles/variables.module.scss';

const CarIconMapper = dynamic(() => import('components/icons/landing/car-brand-icons/mapper'));

const QuotationAvailableByCarsTable = ({ culture, colorSchema, companyCode, familyCodeList, carBrand, pageCode }) => {
    const t = useRichTranslation();
    // const t = useRichTranslation('table.quotation-available-by-car');
    const [isOpen, setOpen] = useState(true);
    const [isSmallSize, setSmallSize] = useState(false);
    const [data, setData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [maxCovLen, setMaxCovLen] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useCustomMediaQuery(Constants.MEDIA_QUERIES.LG, (e) =>
        setSmallSize(!e.matches)
    );

    useEffect(() => {
        const getQuotationByCarCategoryData = async (params) => {
            const response = getDynamicData(params, null, 'quotation-top-model');

            response.then((result) => {
                if (result.status === 200) {
                    const parsedData = getQuotationAvailableByCar(
                        result.data.results, familyCodeList, culture);
                    setData(parsedData.items);
                    setMaxCovLen(removeDuplicateCoverages(result.data.results).length);
                    setHeaders(parsedData.headers);
                    setLoading(false);
                } else {
                    setError(true);
                    setLoading(false);
                }
            })
                .catch((_err) => {
                    setError(true);
                    setLoading(false);
                });
        };

        const params = {
            page_code: pageCode,
            filer_by: ['company'],
            top_model_type: 'medium'
        };
        getQuotationByCarCategoryData(params);
    }, []);

    if (isSmallSize) {
        return (
            <>
                {data.map((item, index) => {
                    return (
                        <QuotationAvailableByCarSmallItem
                            carBrand={data.car_brand}
                            buttonLabel={t('table.quotation-available-by-car.item.cta-label')}
                            buttonHref={t('quoter')}
                            carName={item.car_name}
                            colorSchema={colorSchema}
                            familyName={item.family_name}
                            key={`${item.family_code}+${index}`}
                            price={item.price}
                            peopleChoice={item.selection_percentage}
                        />
                    );
                })}
            </>
        );
    }

    return (
        <>
            <div className={`${titleStyles.label} ${titleStyles.table_title}`}>
                <h2>
                    {t('table.quotation-available-by-car.title')}
                </h2>
            </div>

            { !loading && error && <ErrorMessage /> }

            <TableWrapper sixColumn={true}>
                {
                    !error && <HeaderExpansibleBase
                        colorSchema={colorSchema}
                        isOpen={isOpen}
                        topNode={
                            <Image
                                src={insuranceLogoMapper(
                                    companyCode,
                                    culture,
                                    'white'
                                )}
                                alt={`${companyCode} Logo`}
                                width={170.21}
                                height={60}
                            />
                        }
                        midNode={
                            <div className={styles.header__mid_label}>
                                {carBrand && (
                                    <CarIconMapper
                                        input={carBrand}
                                        color={variables.whiteColor}
                                        height={32}
                                    />
                                )}
                                <p>{t('table.quotation-available-by-car.header.title')}</p>
                            </div>
                        }
                    />
                }

                { !loading && !error && headers && data.length > 0 &&
                    <QuotationAvailableByCarsHeader
                        isOpen={isOpen}
                        setOpen={setOpen}
                        colorSchema={colorSchema}
                        headers={headers}
                    />
                }
                { loading && <LoadingTable /> }

                { !loading && !error &&
                    <>
                        {data.map((item, index) => (
                            <QuotationAvailableByCarsItem
                                key={`${item.family_code}+${index}`}
                                isOpen={isOpen}
                                setOpen={setOpen}
                                colorSchema={colorSchema}
                                price={item.price}
                                familyCode={item.family_name}
                                coverItems={item.coverages_count}
                                items={item.coverages_items}
                                totalCoverItems={maxCovLen}
                                peopleChoice={item.selection_percentage}
                                carName={item.car_name}
                            />
                        ))}
                    </>
                }
            </TableWrapper>
        </>
    );
};

QuotationAvailableByCarsTable.propTypes = {
    culture: PropTypes.string,
    colorSchema: PropTypes.string,
    companyCode: PropTypes.string,
    familyCodeList: PropTypes.array,
    carBrand: PropTypes.string,
    pageCode: PropTypes.string
};

export default QuotationAvailableByCarsTable;
